var _defs, _g, _g2, _g3, _g4, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeliverMixerTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b6c48f62-fb10-42ba-96a9-6186b2c047db",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a2014eb2-7122-4b54-af5e-0cd0679cbf2d,.ac771276-5a80-4a54-8602-8c049f4ec886{fill:none;}.a2014eb2-7122-4b54-af5e-0cd0679cbf2d{clip-rule:evenodd;}.fe1eeeb0-1eb6-4ce6-b3f1-1daf54016796{clip-path:url(#a6ab314a-70a2-4611-8a52-0db08143862c);}.e755cb82-8b75-442d-9c3b-dcbdf3cef76e{fill:#d8d8d8;}.a2d52a21-2d57-4487-9237-930514a8c36c{clip-path:url(#b5ad9991-00aa-42bf-9f40-094f4bb0780e);}.a841c9ae-1bef-4b49-b342-c7e15b5f0e8a{clip-path:url(#a8e04ac2-0a69-4292-9d45-bcdf3da484b4);}.ab76c14b-fc38-4025-b6a8-7c63a4f893f8{clip-path:url(#b7ac6496-88cb-4408-968f-92203b17c9ee);}.b40fbf1e-13ba-4a42-99ff-e5cc748870dd{clip-path:url(#aafa5d5e-e74c-41ac-ba54-99956d212a4c);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a6ab314a-70a2-4611-8a52-0db08143862c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ac771276-5a80-4a54-8602-8c049f4ec886",
    d: "M17.33,11.75a.28.28,0,0,0,.26.3h4.54a.28.28,0,0,0,.26-.29V11.5a.66.66,0,0,0-.05-.28L20.91,8.48a.62.62,0,0,0-.58-.39H17.81c-.41,0-.48,0-.48.5ZM2.11,15.34a1,1,0,0,1,1-.94h12.6a.59.59,0,0,0,.59-.6V7.32a.18.18,0,0,1,.18-.18h4.3a.94.94,0,0,1,.86.57l2.12,4v0a1,1,0,0,1,.08.38l-.05,7.55a1,1,0,0,1-.95.95h-.14a.18.18,0,0,1-.18-.18,3.18,3.18,0,1,0-6.35,0,.18.18,0,0,1-.18.18H15a.18.18,0,0,1-.18-.18,3.17,3.17,0,0,0-5.87-1.69.17.17,0,0,1-.3,0,3.17,3.17,0,0,0-5.84,1.74.22.22,0,0,0,0,.08,1,1,0,0,1-.71-1Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b5ad9991-00aa-42bf-9f40-094f4bb0780e"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ac771276-5a80-4a54-8602-8c049f4ec886",
    d: "M19.31,21.34a.9.9,0,1,0-.89-.9A.89.89,0,0,0,19.31,21.34Zm0-3.44a2.54,2.54,0,1,1-2.52,2.54A2.52,2.52,0,0,1,19.31,17.9Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a8e04ac2-0a69-4292-9d45-bcdf3da484b4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ac771276-5a80-4a54-8602-8c049f4ec886",
    d: "M11.63,21.34a.9.9,0,1,0-.89-.9A.89.89,0,0,0,11.63,21.34Zm0-3.44a2.54,2.54,0,1,1-2.52,2.54A2.52,2.52,0,0,1,11.63,17.9Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b7ac6496-88cb-4408-968f-92203b17c9ee"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ac771276-5a80-4a54-8602-8c049f4ec886",
    d: "M6,21.35a.89.89,0,1,0-.89-.89A.88.88,0,0,0,6,21.35Zm0-3.43a2.54,2.54,0,1,1-2.52,2.54A2.52,2.52,0,0,1,6,17.92Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aafa5d5e-e74c-41ac-ba54-99956d212a4c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a2014eb2-7122-4b54-af5e-0cd0679cbf2d",
    d: "M.36,7.69,1.2,5.37a1.65,1.65,0,0,1,1.05-1L7,2.85l.26-.06A.17.17,0,0,1,7.4,3L6,6.88a.58.58,0,0,0,.24.7A.52.52,0,0,0,7,7.29L8.41,3.35a.26.26,0,0,1,.35-.16l2.88,1.15a.29.29,0,0,1,.16.38l-1.46,4a.59.59,0,0,0,.24.71.52.52,0,0,0,.74-.29l1.45-4A.24.24,0,0,1,13.15,5a1,1,0,0,1,.18.18l1.53,1.86a1.8,1.8,0,0,1,.31,1.66L14,12.34a1.63,1.63,0,0,1-1.54,1.17H4.21a1.6,1.6,0,0,1-1.33-.74L.55,9.27A1.77,1.77,0,0,1,.36,7.69Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "fe1eeeb0-1eb6-4ce6-b3f1-1daf54016796"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e755cb82-8b75-442d-9c3b-dcbdf3cef76e",
    x: -2.92,
    y: 2.14,
    width: 31.72,
    height: 23.42
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "a2d52a21-2d57-4487-9237-930514a8c36c"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e755cb82-8b75-442d-9c3b-dcbdf3cef76e",
    x: 11.79,
    y: 12.9,
    width: 15.03,
    height: 15.08
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "a841c9ae-1bef-4b49-b342-c7e15b5f0e8a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e755cb82-8b75-442d-9c3b-dcbdf3cef76e",
    x: 4.11,
    y: 12.9,
    width: 15.03,
    height: 15.08
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "ab76c14b-fc38-4025-b6a8-7c63a4f893f8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e755cb82-8b75-442d-9c3b-dcbdf3cef76e",
    x: -1.56,
    y: 12.92,
    width: 15.03,
    height: 15.08
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "b40fbf1e-13ba-4a42-99ff-e5cc748870dd"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e755cb82-8b75-442d-9c3b-dcbdf3cef76e",
    x: -4.74,
    y: -2.21,
    width: 25,
    height: 20.71
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliverMixerTruck);
export default __webpack_public_path__ + "static/media/deliver-mixer-truck.2e83b66bba1bf83671d9aaed9e08fc9f.svg";
export { ForwardRef as ReactComponent };